import type { IndicacaoAmigo } from "../../../services/indicacoesAmigos"

export type IndicacoesAmigosModel = {
    indicacoes: IndicacaoAmigo[]
}

export const IndicacoesAmigosInicial: IndicacoesAmigosModel = {
    indicacoes: [],
}
